import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpService } from "src/app/backend/http.service";
import { ISignUpSetting } from "src/app/models/settings/sign-up-setting";
import jwtDecode from "jwt-decode";
import { AppSetting } from "src/app/backend/app-setting";

@Injectable({
  providedIn: "root",
})
export class SettingService {
  constructor(private httpService: HttpService) {}

  getSignUpSetting(): Observable<ISignUpSetting> {
    var decoded: any = jwtDecode(
      localStorage.getItem(AppSetting.tokenKey) as string,
    );

    return this.httpService
      .get<ISignUpSetting>(
        "settings/timebanksetting?OrgCode=" +
          decoded[
            "http://schemas.microsoft.com/ws/2008/06/identity/claims/groupsid"
          ],
      )
      .pipe(map((value) => value.result));
  }

  setSignUpSetting(setting: ISignUpSetting): Observable<any> {
    return this.httpService.post("settings/timebanksetting", setting);
  }

  getFilter(id: number): Observable<any> {
    return this.httpService
      .get<any>(`settings/filters?Id=${id}`)
      .pipe(map((value) => value.result));
  }

  createFilters(model: {
    Filters: {
      Data: string;
      OrderIdx?: number;
      ParentId?: number;
      Enabled?: boolean;
    }[];
  }): Observable<any> {
    return this.httpService
      .post("settings/filters", model)
      .pipe(map((value) => value.result));
  }

  updateFilters(model: {
    Filters: {
      Id: number;
      Data?: string;
      OrderIdx?: number;
      ParentId?: number;
      Enabled?: boolean;
    }[];
  }): Observable<any> {
    return this.httpService
      .put("settings/filters", model)
      .pipe(map((value) => value.result));
  }
}
